import { createContext } from "react";
import type { Identifier } from "ra-core";

/** The rows a bulk action is working on, so the table shows a spinner on them */
export const PreLeadBusyContext = createContext<{
  busy: Set<Identifier>;
  setBusy: (update: (busy: Set<Identifier>) => Set<Identifier>) => void;
}>({ busy: new Set(), setBusy: () => {} });
